import { Component, OnInit, EventEmitter, Input, Output, SimpleChange } from '@angular/core';
import { UtilService } from '../../services/util.service';

@Component({
    selector: 'dhs-pagination',
    templateUrl: './data-grid-pagination.component.html',
    styleUrls: ['./data-grid-pagination.component.css'],
    standalone: false
})
export class DataGridPaginationComponent implements OnInit {
    @Input() gridConfig: any = {};
    @Input() itemsCount: number;
    @Input() limit: number;
    @Input() startPage: number;
    @Output() pageChange = new EventEmitter();
    @Output() onPageChanges = new EventEmitter();
    @Output() onLimitChanges = new EventEmitter();
    @Output() onConfigChanges = new EventEmitter();

    private pages: Array<number>;
    public pageLimit: Array<number> = [10, 25, 50, 100];
    currentPage = 1;
    pageCount: number;
    //visiblePages: Array<number>;
    showPages: boolean = false;
    config: any = {hidegetCount:false};

    constructor(public utilService: UtilService) { }

    ngOnInit() {
        this.config.showCount = 1;//1 means count will be shown
        // console.log("Abc ", this.itemsCount, this.limit, this.startPage);
        this.limit = this.gridConfig != undefined && this.gridConfig.APIresource && this.gridConfig.APIresource.datasource && this.gridConfig.APIresource.datasource.page_size != undefined ? this.gridConfig.APIresource.datasource.page_size : this.limit;

        if (this.gridConfig != undefined && this.gridConfig.noCount != undefined && this.gridConfig.noCount) {
            this.config.showCount = -1;
        }

        if (this.gridConfig != undefined && this.gridConfig.page_limit != undefined && this.gridConfig.page_limit) {
            this.pageLimit = this.gridConfig.page_limit;
        }


        this.setPages();
        if (this.itemsCount != undefined && this.itemsCount) {
            this.config.totalPages = Math.ceil(this.itemsCount / 10);
        }

        if (this.gridConfig.noCount != undefined && this.gridConfig.noCount && this.gridConfig.noCount == 'hidden') {
            this.config.hidegetCount = true;
        }

    }

    limitChange(event, limit) {
        event.target.value = limit;
        this.limit = event.target.value
        this.onLimitChanges.emit(event);
    }
    ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
        this.config.showCount = 1;//1 means count will be shown
        // console.log("Abc ", this.itemsCount, this.limit, this.startPage);

        if (this.gridConfig != undefined && this.gridConfig.noCount != undefined && this.gridConfig.noCount) {
            this.config.showCount = -1;
        }
        if (this.gridConfig.noCount != undefined && this.gridConfig.noCount && this.gridConfig.noCount == 'hidden') {
            this.config.hidegetCount = true;
        }
        this.setPages();
        if (changes['limit'] || changes['itemsCount']) {
            let startPage = 1;
            if (this.startPage && changes['itemsCount']) {
                if ((this.startPage <= this.pageCount) || this.pageCount == undefined) { // if pagecount is undefined it means that nocount is set to true
                    startPage = this.startPage; //this line doesn't make sense ,not removing because code is working fine :-)
                }
            }
            this.onPageClickInternal(startPage);

        } else if (changes['startPage']) {
            this.onPageClickInternal(changes['startPage']["currentValue"]);
        }
    }
    private onPageChanged(event: any) {
        this.onPageChanges.emit(event);
    }
    showById(id) {
        // if (document.getElementById(id) != undefined && document.getElementById(id)){
        //     document.getElementById(id).classList.toggle("show");
        this.showPages = !this.showPages;
        if (this.showPages && document.getElementById(id) != undefined && document.getElementById(id) && !document.getElementById(id).classList.contains('show')) {
            document.getElementById(id).classList.add("show");
        }
        // }
    }
    showId(id) {
        if (document.getElementById(id) != undefined && document.getElementById(id)) {
            if (this.showPages) {
                this.showPages = false;
                document.getElementById(id).classList.remove("show");
            }
            // this.cdr.detectChanges();
        }

    }
    onPageClick(page: number) {
        if (page !== this.currentPage && page >= 1 && (page <= this.pageCount || this.config.showCount == -1)) {
            // if coming page is less than current page(previous button is clicked) or current itme is not less than limit (it means there is chance of next page)
            if (page < this.currentPage || !(this.gridConfig.currentItemCount < this.limit)) {
                this.currentPage = page;
                this.pageChange.emit({
                    page: this.currentPage
                });
            }

            //this.setVisiblePages();
        }
    }
    onPageClickInternal(page: number) {
        if (page !== this.currentPage && page >= 1 && (page <= this.pageCount || this.config.showCount == -1)) {
            this.currentPage = page;
            //this.setVisiblePages();
        }
    }
    private setPages() {
        if (this.config.showCount == 1) {
            this.pageCount = Math.ceil(this.itemsCount / this.limit);
        }
        //this.setVisiblePages();
    }

    getCount() {
        this.onConfigChanges.emit({ config: "getCount" });
    }
    // private setVisiblePages() {
    //     if (this.pageCount < 6) {
    //         this.visiblePages = Array.apply(null, { length: this.pageCount }).map((x: number, i: number) => i + 1);
    //     } else {
    //         if (this.currentPage >= this.pageCount - 3) {
    //             const diff = this.pageCount - this.currentPage;
    //             const startPage = this.pageCount - 4;
    //             this.visiblePages = Array.apply(null, { length: 5 }).map((x: number, i: number) => startPage + i);
    //         } else {
    //             if (this.currentPage < 3) {
    //                 const startPage = 1;
    //                 this.visiblePages = Array.apply(null, { length: 5 }).map((x: number, i: number) => startPage + i);
    //             } else {
    //                 const startPage = this.currentPage - 2;
    //                 this.visiblePages = Array.apply(null, { length: 5 }).map((x: number, i: number) => startPage + i);
    //             }
    //         }
    //     }
    // }
}
